import { SvgIcon, SxProps } from "@mui/material";
import Icon from "jsx:../../../Images/Icons/FontAwesome/regular/circle-exclamation.svg";

export function CircleExclamationRegular(props: SxProps) {
    return <SvgIcon component={Icon} inheritViewBox sx={props} />;
}
